module.exports = __webpack_public_path__ + "img/index-m-slide3.e7c838a9.jpg";